import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import config from '../config';
import axios from 'axios';

interface SiteInfo {
  title: string;
  name: string;
  description: string;
  logo: string;
  icon: string;
  phone: string;
  email: string;
  address: string;
  map_html: string;
  copyright: string;
}
interface SocialInfo {
  id: number;
  name: string;
  icon: string;
  image: string;
  link_url: string;
  target: string;
  status: number;
}

const App: React.FC = () =>  {
  const [siteInfo, setSiteInfo] = useState<SiteInfo | null>(null);
  const [socialInfo, setSocialnfo] = useState<SocialInfo[]>([]);

  //function Siteinfo
  const fetchSiteInfo = async () => {
      try {
          const response = await axios.get<{ data: SiteInfo }>(config.apiUrl+'siteinfo');
          if (response.status === 200) {
              setSiteInfo(response.data.data);        
          } else {
              console.error('Failed to fetch site information');
          }
      } catch (error) {
          console.error('Error fetching data:', error);
      }
  };
 //function Socialinfo
 const fetchSocial = async () => {
  try {
    const response = await axios.get<{ data: SocialInfo[] }>(config.apiUrl + 'social');
    if (response.status === 200) {
      setSocialnfo(response.data.data);
    } else {
      console.error('Failed to fetch social information');
    }
  } catch (error) {
    console.error('Error fetching social data:', error);
  }
};
  useEffect(() => {
      fetchSiteInfo();
      fetchSocial();
      // console.log(siteInfo);                    
  },[]); 
  
  return (
    <div className="App">
      <hr/>
      <footer className="footer">
        <div className="container">
          <div className="row py-4">
            <div className="col-md-8 col-sm-12">
              <div className="footer-center text-sm-start text-center">
                <h5>সেবা  ও পেজসমূহ</h5>
                <div className='footer-border'>
                  <div className="row">
                      <div className="col-md-4 mt-sm-3">
                        <ul className="p-0">
                          <li><Link to="/about">প্রাক-নিবন্ধন</Link></li>
                          <li><Link to="/">নিবন্ধন</Link></li>
                          <li><Link to="/privacy-policy">প্রাক-নিবন্ধন রিফান্ড</Link></li>
                          <li><Link to="/contact-us">যোগাযোগ </Link></li>
                        </ul>
                      </div>
                      <div className="col-md-4 mt-sm-3">
                        <ul className="p-0">
                          <li><Link to="/">ধর্ম বিষয়ক মন্ত্রণালয় </Link></li>
                          <li><Link to="/">হজ অফিস, ঢাকা </Link></li>
                          <li><Link to="/privacy-policy">প্রাইভেসি পলিসি</Link></li>
                        </ul>
                      </div>
                      <div className="col-md-4 mt-sm-3">
                        <ul className="p-0">
                          <li><Link to="/">সৌদি ই- ভিসা লিংক </Link></li>
                          <li><Link to="/">সৌদি হজ ও ওমরাহ মন্ত্রণালয় </Link></li>
                          <li><Link to="/">বিমান বাংলাদেশ এয়ারলাইন্স</Link></li>
                          <li><Link to="/contact-us">হজ অফিস, ঢাকা</Link></li>
                        </ul>
                      </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4 col-sm-12">
              <div className="footer-left mt-sm-5 mt-4 text-center">
                {/* <img src={`${config.fileUrl+siteInfo?.logo}`} alt=""/> */}
               <h3 className=''> <img className="" src='./assets/img/logo_icon.png' alt="" style={{maxWidth: '100px', marginTop: '0', height: '100px'}} /> ফরাজী এভিয়েশন</h3> 
                <p className="mb-0 pt-4">ফরাজী ভিলা, উলানিয়া বন্দর, গলাচিপা, পটুয়াখালী</p>
                <p className="mb-0 pb-4">মোবাইলঃ +৮৮০ ১৬০৪ ০৭৫৫৫৫, +৮৮০ ১৭১৬ ০৭১০৭৭</p>
                <div className="social-icon mb-5">
                    {socialInfo.map((info) => (
                      <Link to={info.link_url} key={info.id} target={info.target}>
                        <span dangerouslySetInnerHTML={{ __html: info.icon }}></span>
                      </Link>
                    ))}
                  {/* <Link to="#0"><i className="fa-brands fa-twitter twitter"></i></Link> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        <p className="text-center copyright m-0 text-white" > Copyright @ 2025</p>
      </footer>
    </div>
  );
}

export default App;